import React, { useEffect, useContext, useState } from 'react'
import { PiChatCircleDots } from 'react-icons/pi'
import { disabledHorarios } from '../../../Complex/ButtonHorario/functions'
import { EmpresasContext } from '../../../../contexts/EmpresasContext'
import { Typography, Box, Tooltip } from '@mui/material'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { ButtonHorario } from '../../../Complex'
import { Loading } from '../../../Simple'
import { AgendamentoContext } from '../../../../contexts/AgendamentoContext'

export default function GradeHorarios({ quadra, horarios, desativarGrade }) {
  const { sttCtxAgend } = useContext(AgendamentoContext)
  const { sttPg, loads, actionsCtxEmps } = useContext(EmpresasContext)
  const { userUCtx } = useContext(UsuarioContext)

  const reagendamento = sttCtxAgend.reagendamento

  const FormaPagamentoIncompativelReagendamento = () => {
    if (Object.keys(reagendamento).length > 0) {
      const tipoPagamento = quadra.regraAgendamento.tipoPagamento
      switch (tipoPagamento) {
        case 'SINAL':
          if (
            reagendamento.valorTotal !== reagendamento.valorAPagar &&
            reagendamento.valorRealizado !== 0 &&
            reagendamento.valorAPagar !== 0
          ) {
            return false
          }
          break
        case 'TOTAL':
          if (
            reagendamento.valorTotal !== reagendamento.valorAPagar &&
            reagendamento.valorRealizado !== 0 &&
            reagendamento.valorAPagar !== 0
          ) {
            return true
          }
          break
        case 'AMBOS':
          return false
        default:
          return false
      }
    }
  }

  const [invalidGrade, setInvalidGrade] = useState(
    Object.keys(reagendamento).length === 0 ? false : FormaPagamentoIncompativelReagendamento(),
  )

  useEffect(() => {
    if (FormaPagamentoIncompativelReagendamento()) return
    if (sttPg.selectedHorarios.length > 0) {
      actionsCtxEmps.toggleResumoDrawer(true)
      let flag = true
      for (let horario of horarios) {
        if (sttPg.selectedHorarios[0].idgrade === horario.idgrade) {
          flag = false
          break
        }
      }
      setInvalidGrade(flag)
    } else setInvalidGrade(false)
  }, [sttPg.selectedHorarios])

  const handleHorarioChange = (horario, isChecked) => {
    actionsCtxEmps.handleSelectHorario(horario, isChecked)
  }

  const ReturnLabel = quadra => {
    if (sttPg.messagesQuadras.length > 0) {
      const item = sttPg.messagesQuadras.find(item => item.idquadra === quadra.idquadra)
      if (item) return item.message || 'Não há horários disponíveis para este dia'
      else return 'Não há horários disponíveis para este dia'
    } else {
      return 'Não há horários disponíveis para este dia'
    }
  }

  return (
    <>
      {loads.gradeHorarios ? (
        <Loading />
      ) : desativarGrade || !horarios.length ? (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <PiChatCircleDots size={40} color='#424242' />
          </Box>
          <Typography variant='body2' align='center'>
            {ReturnLabel(quadra)}
          </Typography>
        </>
      ) : (
        <>
          <Tooltip
            title={
              invalidGrade ? (
                <Typography>Forma de pagamento incompatível com o reagendamento</Typography>
              ) : (
                ''
              )
            }
            placement='bottom'
          >
            <Box
              sx={{
                display: 'flex',
                overflowX: 'auto',
                gap: 1,
                p: 1,
                '&::-webkit-scrollbar': {
                  height: 8,
                },
              }}
            >
              {horarios.map((horario, index) => (
                <React.Fragment key={index}>
                  <ButtonHorario
                    horario={horario}
                    isNobre={horario.nobre}
                    onChange={isChecked => handleHorarioChange(horario, isChecked)}
                    disabled={disabledHorarios(userUCtx, sttPg, horario, invalidGrade)}
                    isSelected={sttPg.selectedHorarios.some(
                      selected => selected.idHorario === horario.idHorario,
                    )}
                    sttCtxAgend={
                      sttCtxAgend.reagendavel
                        ? sttCtxAgend.reagendavel.idHorario === horario?.idHorario
                        : false
                    }
                    reagendavel={
                      horario?.idpedido
                        ? sttCtxAgend.reagendamento.idpedido === horario.idpedido
                        : false
                    }
                  />
                </React.Fragment>
              ))}
            </Box>
          </Tooltip>
        </>
      )}
    </>
  )
}
